import { Stack, Text, IconSearch, Box, ButtonLink } from 'braid-design-system';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import { getConfigValues } from 'src/config';
import FloatingHeartSvg from 'src/images/floating-heart.svg';

const NoResultsPanel = () => (
  <Box paddingY="large">
    <Stack space="small" align="center">
      <CustomSvg svg={FloatingHeartSvg} width={45} height={57} />

      <Box id="saved-businesses-no-results-heading">
        <Text>Looks like you don&apos;t have any saved businesses yet</Text>
      </Box>

      <Box id="saved-businesses-no-results-text">
        <Text>Let&apos;s get busy!</Text>
      </Box>

      <Box paddingTop="medium">
        <ButtonLink
          id="saved-businesses-no-results-btn"
          tone="formAccent"
          href={`${getConfigValues().HEADER_SERVER_BASE}/businesses-for-sale`}
          icon={<IconSearch />}
        >
          Search for businesses
        </ButtonLink>
      </Box>
    </Stack>
  </Box>
);

export default NoResultsPanel;
